define('app/sdc/md/autocomplete/controller/sdc-md-autocomplete-controller',[],function () {
	"use strict";
	return {
		restrict: "A",
		require: "?mdAutocomplete",
		scope: false,
		template: null,
		controller: {
			bind: {
				"ctrl": "=sdcMdAutocompleteController"
			}
		},
		link: ["$self", "$controllers", function (vm, mdAutocompleteCtrl) {
			vm.ctrl = mdAutocompleteCtrl;
		}]
	};
});
